import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Dashboard from "./pages/Admin";
import Login from "./pages/Login";

const App = () => {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/dash" component={Dashboard} />
          <Route exact path="/" render={() => <Redirect to="/login" />} />
        </Switch>
      </Router>
    </>
  );
};

export default App;
